import api from './api'
import { toast } from 'react-toastify'

export function favoriteIndustrializado(farmaciaId, usuarioId, industrializadoId) {
  return new Promise(async (resolve, reject) => {
    try {
      const token = localStorage.getItem('FORMULARIO_JSONWEBTOKEN');

      await api.post(`farmacias/${farmaciaId}/usuarios/${usuarioId}/medicamentos_industrializados/${industrializadoId}/favorite`, {}, {
        headers: { authorization: `Bearer: ${token}` }
      });

      return resolve();
    } catch (e) {
      toast.error("Falha ao adicionar industrializado aos favoritos");
      return reject(e);
    }
  })
}

export function unfavoriteIndustrializado(farmaciaId, usuarioId, industrializadoId) {
  return new Promise(async (resolve, reject) => {
    try {
      const token = localStorage.getItem('FORMULARIO_JSONWEBTOKEN');

      await api.delete(`farmacias/${farmaciaId}/usuarios/${usuarioId}/medicamentos_industrializados/${industrializadoId}/favorite`, {
        headers: { authorization: `Bearer: ${token}` }
      });

      return resolve();
    } catch (e) {
      toast.error("Falha ao remover industrializado dos favoritos");
      return reject(e);
    }
  })
}

export function findAllFavoriteIndustrializados(farmaciaId, usuarioId) {
  return new Promise(async (resolve, reject) => {
    try {
      const token = localStorage.getItem('FORMULARIO_JSONWEBTOKEN');

      const response = await api.get(`farmacias/${farmaciaId}/usuarios/${usuarioId}/medicamentos_industrializados/favorites/all`, {
        headers: { authorization: `Bearer ${token}` }
      });

      return resolve(response.data.data);
    } catch (e) {
      toast.error("Falha ao buscar favoritos");
      return reject(e);
    }
  })
}

export function findFavoriteIndustrializados(farmaciaId, usuarioId, page = 1, itemsPerPage = 15, ref = '') {
  return new Promise(async (resolve, reject) => {
    try {
      const token = localStorage.getItem('FORMULARIO_JSONWEBTOKEN');

      const response = await api.get(`farmacias/${farmaciaId}/usuarios/${usuarioId}/medicamentos_industrializados/favorites`, {
        headers: { authorization: `Bearer ${token}` },
        params: { ref, page, itemsPerPage }
      });

      return resolve(response.data);
    } catch (e) {
      toast.error("Falha ao buscar favoritos");
      return reject(e);
    }
  })
}
